import type { Locale } from '@skytech/types'
import { mapKeysToSnakeCase } from '@skytech/utils'

import type { UserTypeSymbol } from '@/app/types'
import { API_ROUTE_ADMIN_COST_OBJECT } from '@/resources/api-routes'
import { post } from '@/util/auth'

export const postCostObject = ({
  id,
  payload,
}: {
  id: number
  payload: {
    name: string
    departmentId: number
    email: string | null
    employeeNo: string
    benefitType: UserTypeSymbol
    locale: Locale
    devicePolicyId: number
    salaryDeductionProfileId: number
    fixedSalaryDeductionComment: string
    appMessage: string
    isHidden: boolean
    accountingCode: string | null
    dim1: string | null
    dim2: string | null
    dim3: string | null
    dim4: string | null
  }
}) => {
  const { dim1, dim2, dim3, dim4, ...snakeCasePayload } = mapKeysToSnakeCase(payload)
  const parsedPayload = {
    ...snakeCasePayload,
    dim_1: dim1,
    dim_2: dim2,
    dim_3: dim3,
    dim_4: dim4,
  }
  return post<null>(API_ROUTE_ADMIN_COST_OBJECT.replace(':costObjectId', String(id)), parsedPayload)
}
